export type GridLayoutType =
  | "1"     // Row: one large card
  | "1-1"   // Row: two equal cards
  | "1-2"   // Row: one small + one large
  | "2-1"   // Row: one large + one small
  | "1-1-1" // Row: three small cards

// templates for the entire grid screen

export const GRID_TEMPLATE_1: GridLayoutType[] = [
  "1"
];

export const GRID_TEMPLATE_2: GridLayoutType[] = [
  "1-1"
];
export const GRID_TEMPLATE_3: GridLayoutType[] = [
  "1",
  "1-1",
];
export const GRID_TEMPLATE_4: GridLayoutType[] = Array(10)
  .fill(null)
  .map(() => GRID_TEMPLATE_3[Math.floor(Math.random() * GRID_TEMPLATE_3.length)]);
  
  /* 
export const GRID_TEMPLATE_1: GridLayoutType[] = [
  "1",
  "1-1",
  "1-1-1"
];

export const GRID_TEMPLATE_2: GridLayoutType[] = [
  "1-1",
  "1-2",
  "2-1",
];
export const GRID_TEMPLATE_3: GridLayoutType[] = [
  "1-1-1",
  "1-1",
  "1",
];
export const GRID_TEMPLATE_4: GridLayoutType[] = [
  "1",
  "2-1",
  "1-1"
];

export const GRID_TEMPLATE_5: GridLayoutType[] = [
  "2-1",
  "1",
  "1-1-1",
];
export const GRID_TEMPLATE_6: GridLayoutType[] = [
  "1-1-1",
  "1",
  "1-1",
];
 */
